import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import PrimaryPopup from '../popups/PrimaryPopup';
import { logout } from '../../store/profileReducer';
import { useAppDispatch } from '../../hooks/hooks';

type Props = {
  onClose: () => void;
};

const LogoutPopup = ({ onClose }: Props) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const handleLogout = () => {
    setIsLoading(true);
    dispatch(logout())
      .then(() => navigate('/'))
      .catch(() => false)
      .finally(() => setIsLoading(false));
  };

  return (
    <PrimaryPopup className='sm:max-w-[440px]' onClose={onClose} title={t('log_out')}>
      <div className='pb-8'>
        <p className='text-[15px] leading-relaxed text-ink-600'>{t('are_you_sure_logout')}</p>

        <div className='mt-8 flex gap-3'>
          <button type='button' className='btn btn-outline flex-1' onClick={onClose}>
            {t('cancel')}
          </button>
          <button
            type='button'
            className='btn btn-ink flex-1'
            disabled={isLoading}
            onClick={handleLogout}
          >
            {t('log_out')}
          </button>
        </div>
      </div>
    </PrimaryPopup>
  );
};

export default LogoutPopup;
